import * as React from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import ProfileForm from '../components/forms/ProfileForm';

interface StorageAnsiraProfileFormProps {
  node: IStorageAnsiraProfileForm;
}

const StorageAnsiraProfileForm: React.FC<StorageAnsiraProfileFormProps> = function ({
  node: ansiraProfileForm,
}) {
  const title = ansiraProfileForm.title || '';
  const body = ansiraProfileForm.body?.processed || '';
  return (
    <Container data-id={ansiraProfileForm.drupal_id} className="py-5">
      <Row className="justify-content-md-center">
        <Col md={8}>
          <h2 className="text-center">{title}</h2>
          {/* eslint-disable-next-line react/no-danger */}
          {body && <div className="text-center mb-5" dangerouslySetInnerHTML={{ __html: body }} />}
          <ProfileForm
            indexOfModule={ansiraProfileForm.indexOnPage}
            sourceCode={ansiraProfileForm.source_code}
            settings={ansiraProfileForm.settings}
            language={ansiraProfileForm.langcode}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default StorageAnsiraProfileForm;
